import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark bg-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "container" }, [
      _createElementVNode("a", {
        class: "navbar-brand mx-auto m-2",
        href: "/"
      }, [
        _createElementVNode("img", {
          src: "https://zubayrlatief.github.io/Images-/TRsecurityK9-logo.png",
          alt: "Logo",
          class: "navbar-logo"
        })
      ]),
      _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarNav",
        "aria-controls": "navbarNav",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ]),
      _createElementVNode("div", {
        class: "collapse navbar-collapse",
        id: "navbarNav"
      }, [
        _createElementVNode("ul", { class: "navbar-nav mx-auto text-center" }, [
          _createElementVNode("li", { class: "nav-item" }, [
            _createElementVNode("a", {
              class: "nav-link",
              href: "/"
            }, "OUR MISSION")
          ]),
          _createElementVNode("li", { class: "nav-item dropdown" }, [
            _createElementVNode("a", {
              class: "nav-link dropdown-toggle",
              href: "#",
              id: "servicesDropdown",
              role: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false"
            }, " SECURITY SERVICES "),
            _createElementVNode("ul", {
              class: "dropdown-menu",
              "aria-labelledby": "servicesDropdown"
            }, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "/ArmedResponse"
                }, "ARMED RESPONSE")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "/K9Handling"
                }, "K9 HANDLING")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "/EventSecurity"
                }, "EVENT SECURITY")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "/RIASecurity"
                }, "RESIDENTIAL/INDUSTRIAL/AGRICULTURAL")
              ])
            ])
          ]),
          _createElementVNode("li", { class: "nav-item dropdown" }, [
            _createElementVNode("a", {
              class: "nav-link dropdown-toggle",
              href: "#",
              id: "systemsDropdown",
              role: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false"
            }, " SECURITY SYSTEMS "),
            _createElementVNode("ul", {
              class: "dropdown-menu",
              "aria-labelledby": "systemsDropdown"
            }, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "/SecuritySystems"
                }, "ALARM MONITORING/ELECTRIC FENCING")
              ])
            ])
          ]),
          _createElementVNode("li", { class: "nav-item" }, [
            _createElementVNode("a", {
              class: "nav-link",
              href: "/Contact"
            }, "CONTACT")
          ])
        ])
      ])
    ], -1)
  ])))
}